import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const SiteMapPageWrapper = styled.section`
  margin: 20px 0 100px;
  li {
    margin-bottom: 10px;
  }
`;

const SiteMapPage = (props) => (
  <SiteMapPageWrapper>
    <div className="page-header">
      <h2>Site Map</h2>
    </div>
    <ul type="disc" id="tracks-site-map-list">
      <li>
        <Link to="/">Today's Tracks</Link>
        <br />
        What tracks have been posted today
      </li>

      <li>
        <Link to="/message-board">Message Board / Forums</Link>
        <br />
        Comments about tracks posted or related thoughts about an artist.
      </li>

      <li>
        <Link to="/playlists/recent">List of Playlists</Link>
        <br />
        Explore our recent Dream Chimney Playlists.
      </li>
      <li>
        <Link to="/stats">List of Genres</Link>
        <br />
        All genres or 'file under' categories that have been assigned to tracks
      </li>

      <li>
        <Link to="/chimneys">List of Chimneys</Link>
        <br />
        The list of our current Dream Chimney contributing members
      </li>

      <li>
        <Link to="/search">Search</Link>
        <br />
        Find an artist, track title, album or genre
      </li>
      <li>
        <Link to="/shuffle">Shuffle</Link>
        <br />
        Hit the shuffle button to get a random track from the database, its fun.
      </li>

      <li>
        <Link to="/apply">Apply to Become a Chimney</Link>
        <br />
        Want to post tracks on Dream Chimney ? Apply now by answering a few simple questions to get an account.
      </li>

      <li>
        <Link to="/join">Join Dream Chimney</Link>
        <br />
        Create a basic Dream Chimney account to comment, save favorites and more.
      </li>

      <li>
        <Link to="/about">About the site</Link>
        <br />
        What even is this site?
      </li>

      {/* <li>
        <Link to="/guest/help">Guest Chimney</Link>
        <br />
        Would you like to post a track as a guest?
      </li> */}


    </ul>
  </SiteMapPageWrapper>
);

export default SiteMapPage;
